import { render, staticRenderFns } from "./Aste.vue?vue&type=template&id=72a9735c&"
import script from "./Aste.vue?vue&type=script&lang=ts&"
export * from "./Aste.vue?vue&type=script&lang=ts&"
import style0 from "./Aste.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports